import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { SubscriptionProductType } from '@/models';
import {faCow, faMoneyBillWave, faUserGroup, faVenus} from "@fortawesome/free-solid-svg-icons";
import {faDisplayChartUp, faCalendarRange, faCarWrench} from "@fortawesome/pro-solid-svg-icons";
import type {IconProp} from "@fortawesome/fontawesome-svg-core";
import { useSubscriptionProducts } from '@/contexts/SubscriptionProductsContext';

interface SubscriptionProductTypeIconsProps {
  productTypes: SubscriptionProductType[];
}

export default function SubscriptionProductTypeIcons({ productTypes = [] }: SubscriptionProductTypeIconsProps) {
  const { getProductTypeLabel } = useSubscriptionProducts();

  const FeatureIcon = ({
    icon,
    status,
    tooltip,
  }: {
    icon: IconProp;
    status: boolean;
    tooltip: string;
  }) => (
    <div className="relative group">
      <div className={`w-7 h-7 rounded flex items-center justify-center ${status ? 'bg-blue-100 dark:bg-blue-900/30' : 'bg-gray-200 dark:bg-gray-700'} ${status ? 'opacity-100' : 'opacity-40'}`}>
        <FontAwesomeIcon
          icon={icon}
          className={`w-3.5 h-3.5 ${status ? 'text-blue-600 dark:text-blue-400' : 'text-gray-400 dark:text-gray-600'}`}
        />
      </div>
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 dark:bg-gray-700 text-white text-xs rounded opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap z-10">
        {tooltip}
      </div>
    </div>
  );

  return (
    <div className="flex items-center space-x-2">

      <FeatureIcon icon={faMoneyBillWave}
                   tooltip={getProductTypeLabel('LONGTERM')}
                   status={productTypes.includes('LONGTERM')} />

      <FeatureIcon icon={faDisplayChartUp}
                   tooltip={getProductTypeLabel('SWINGTRADES_LONGTERM')}
                   status={productTypes.includes('SWINGTRADES_LONGTERM')} />

      <FeatureIcon icon={faCow}
                   tooltip={getProductTypeLabel('ALL')}
                   status={productTypes.includes('ALL')} />

      <FeatureIcon icon={faUserGroup}
                   tooltip={getProductTypeLabel('COMMUNITY') + ' || ' + getProductTypeLabel('COMMUNITY_OLD') + ' || ' + getProductTypeLabel('COMMUNITY_BOOST')}
                   status={productTypes.includes('COMMUNITY') || productTypes.includes('COMMUNITY_OLD') || productTypes.includes('COMMUNITY_BOOST')} />

      <FeatureIcon icon={faCalendarRange}
                   tooltip={getProductTypeLabel('DAYTRADING')}
                   status={productTypes.includes('DAYTRADING')} />

      <FeatureIcon icon={faVenus}
                   tooltip={getProductTypeLabel('FRAU_MEETS_BOERSE')}
                   status={productTypes.includes('FRAU_MEETS_BOERSE')} />

      <FeatureIcon icon={faCarWrench}
                   tooltip={getProductTypeLabel('WORKSHOP_01')}
                   status={productTypes.includes('WORKSHOP_01')} />

    </div>
  );
}
